module.exports = require("require3");